import { Fragment } from 'react';
import { BackLink } from '../BackLink/BackLink';
import { HaveAnAccountLink } from '../HaveAnAccountLink/HaveAnAccountLink';
import { HeaderLogo } from '../HeaderLogo/HeaderLogo';
import { ProgressIndicator } from '../ProgressIndicator/ProgressIndicator';
import { AccountSelector, HeaderContainer, HeaderWrapper, Logo } from './Header.styles';
import { useResponsiveness } from '../../responsiveness/useResponsiveness';
import { StepProgressIndicator } from '../StepProgressIndicator/StepProgressIndicator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Header = ({
  totalSteps = 0,
  currentStepNumber = 0,
  accountLinkMessage,
  accountLinkHref = '',
  showProgressIndicator,
  showStepProgressIndicator,
  showLogo,
  showHaveAnAccountLink,
  logoAltText = '',
  logoImageSrc,
  showBackLink,
  onAccountLinkClick,
  onLogoClick,
  onBackLinkClick,
  shouldLogoBeClickable,
  shouldHalveProgressBar,
  stepNames = [],
  stepIndex = 0,
  logoWidth,
  logoHeight
}) => {
  const {
    isDesktop
  } = useResponsiveness();
  const displayBackLink = !isDesktop && showBackLink;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [showProgressIndicator && /*#__PURE__*/_jsx(ProgressIndicator, {
      totalSteps: totalSteps,
      currentStepNumber: currentStepNumber,
      shouldHalveProgressBar: shouldHalveProgressBar
    }), /*#__PURE__*/_jsxs(HeaderWrapper, {
      children: [/*#__PURE__*/_jsxs(HeaderContainer, {
        children: [showLogo && /*#__PURE__*/_jsx(Logo, {
          children: /*#__PURE__*/_jsx(HeaderLogo, {
            altText: logoAltText,
            showMobileView: !isDesktop,
            imageSrc: logoImageSrc,
            height: logoHeight,
            onClick: onLogoClick,
            shouldLogoBeClickable: shouldLogoBeClickable,
            width: logoWidth
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [showHaveAnAccountLink && /*#__PURE__*/_jsx(AccountSelector, {
            displayBackLink: displayBackLink,
            children: /*#__PURE__*/_jsx(HaveAnAccountLink, {
              href: accountLinkHref,
              accountLinkMessage: accountLinkMessage,
              onClick: onAccountLinkClick
            })
          }), displayBackLink && /*#__PURE__*/_jsx(BackLink, {
            onClick: onBackLinkClick
          })]
        })]
      }), showStepProgressIndicator && /*#__PURE__*/_jsx(StepProgressIndicator, {
        stepIndex: stepIndex,
        stepNames: stepNames
      })]
    })]
  });
};